import queryString from 'query-string'
import { usingGet } from '@ocean/api'
import { GetSimulatorExercisePersonLastSessionModel } from 'modules/simulatorTrainings/common/types/student'

export const getSimulatorExercise = (exerciseId: Guid) =>
  usingGet(`SimulatorTrainings/GetSimulatorExercise?exerciseId=${exerciseId}`)

export const getSimulatorExerciseSchedule = (scheduleId: Guid) =>
  usingGet(`SimulatorTrainings/GetSimulatorExerciseSchedule?scheduleId=${scheduleId}`)

export const getListStudentLedEnrollments = (scheduleId: Guid) =>
  usingGet(`SimulatorTrainings/studentLed/schedules/${scheduleId}/enrollments`, {
    useProxy: true,
  })

export const getSimulatorExercisePersonLastSession = (
  params: GetSimulatorExercisePersonLastSessionModel
) => {
  const queryParams = queryString.stringify(params, { skipNull: true })
  return usingGet(`SimulatorTrainings/GetSimulatorExercisePersonLastSession?${queryParams}`)
}
